import { useMemo, useRef, useState } from "react";
import { CategoryForm } from "../../components/forms/CategoryForm";
import Modal from "../../components/ui/Modal";
import type { CategorySummary } from "../../services/category/category.types";

interface Props {
    category: CategorySummary | null;
    onSaved: (category: CategorySummary, warning?: string) => Promise<void>;
    onCancel: () => void;
}

export function CategoryEditor({ category, onSaved, onCancel }: Props) {
    const formRef = useRef<HTMLFormElement>(null);
    const [submitting, setSubmitting] = useState(false);
    const initialData = useMemo(() => category ? {
        name: category.name, description: category.description, isActive: category.isActive,
        associatedSites: category.associatedSites,
    } : undefined, [category]);
    return (
        <Modal isOpen title={category ? "Edit Category" : "Add Category"}
            okButtonLoading={submitting} cancelButtonLoading={submitting}
            onConfirm={() => { if (!submitting) formRef.current?.requestSubmit(); }}
            onCancel={() => { if (!submitting) onCancel(); }}
            content={<CategoryForm formRef={formRef} initialData={initialData} categoryId={category?.id}
                isLoading={submitting} onSubmitting={setSubmitting} onSubmit={onSaved} />}
        />
    );
}
